const routeCodeConfig = {
  product: { prefix: 'p', multiplier: 104729, salt: 73471 },
  news: { prefix: 'n', multiplier: 130363, salt: 91823 },
  video: { prefix: 'v', multiplier: 156007, salt: 62743 }
}

function normalizeId(id) {
  const value = Number(id)
  return Number.isInteger(value) && value > 0 ? value : 0
}

function checksum(id, salt) {
  return String((id + salt) % 97).padStart(2, '0')
}

export function encodeRouteCode(type, id) {
  const config = routeCodeConfig[type]
  const value = normalizeId(id)
  if (!config || !value) return ''
  const payload = (value * config.multiplier + config.salt).toString(36)
  return `${config.prefix}-${payload}${checksum(value, config.salt)}`
}

export function decodeRouteCode(type, code) {
  const config = routeCodeConfig[type]
  const value = String(code || '')
  const prefix = config && `${config.prefix}-`
  if (!config || value.indexOf(prefix) !== 0) return ''
  const body = value.slice(prefix.length)
  if (body.length <= 2) return ''
  const payload = body.slice(0, -2)
  const check = body.slice(-2)
  const raw = Number.parseInt(payload, 36)
  if (!Number.isFinite(raw)) return ''
  const id = (raw - config.salt) / config.multiplier
  if (!Number.isInteger(id) || id <= 0) return ''
  return checksum(id, config.salt) === check ? id : ''
}

export function buildPcDetailPath(type, id) {
  const code = encodeRouteCode(type, id)
  return code ? `/pc/${type}/${code}` : '/pc'
}
